import { useForm, useFormState } from 'react-final-form'
import { Alias } from '../../../redux/types/products'
import { ProductForm } from '../../../redux/types/products'
import { Duplicates } from '../../../utils/aliases/Duplicates'
import { useDeepEffect } from '../AliasRemap/hooks/useDeepEffect'

/**
 * This component is used to find the padded duplicate aliases
 * on the product form and mark them for deletion as we don't
 * want these aliases in the system as they cause confusion.
 */
export const DeleteDuplicateAliases = () => {
  const { mutators } = useForm()
  const { values } = useFormState<ProductForm>()

  useDeepEffect(() => {
    const aliases: Alias[] = (values.aliases_attributes || []) as Alias[]

    const duplicates = new Duplicates(aliases)

    aliases.forEach((alias, i) => {
      if (duplicates.isPaddedDuplicate(alias)) {
        mutators.update('aliases_attributes', i, { ...alias, _destroy: true })
      }
    })
  }, [mutators, values.aliases_attributes])

  return null
}
